import { render } from "./ChapkaInsurance.vue?vue&type=template&id=06c28cb3&scoped=true"
import script from "./ChapkaInsurance.vue?vue&type=script&lang=js"
export * from "./ChapkaInsurance.vue?vue&type=script&lang=js"

import "./ChapkaInsurance.vue?vue&type=style&index=0&id=06c28cb3&scoped=true&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c28cb3"]])

export default __exports__